// Copyright (C) Microsoft Corporation. All rights reserved.

export function propagateEmbedParams(): void {
	const params = new URLSearchParams(window.location.search);
	const showNav = params.get("shownav");
	const noChrome = params.has("nochrome");

	if (!noChrome && showNav !== "false") {
		return;
	}

	const currentHost = window.location.host;

	document.querySelectorAll<HTMLAnchorElement>(".learnArticleContent a[href]").forEach((link) => {
		try {
			const url = new URL(link.href, window.location.origin);

			if (url.host !== currentHost) {
				return;
			}

			if (showNav === "false" && !url.searchParams.has("shownav")) {
				url.searchParams.set("shownav", "false");
			}

			if (noChrome && !url.searchParams.has("nochrome")) {
				url.searchParams.set("nochrome", "");
			}

			link.href = url.toString();
		} catch {
		}
	});
}
